"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const About_1 = __importDefault(require("./landingBody/about/About"));
const Advantages_1 = __importDefault(require("./landingBody/advantages/Advantages"));
const Contact_1 = __importDefault(require("./landingBody/contact/Contact"));
const Introduction_1 = __importDefault(require("./landingBody/introduction/Introduction"));
const LandingFooter_1 = __importDefault(require("./landingFooter/LandingFooter"));
const LandingForm_1 = __importDefault(require("./landingForm/LandingForm"));
const LandingHeader_1 = __importDefault(require("./landingHeader/LandingHeader"));
const LandingPage = () => {
    const aboutRef = (0, react_1.useRef)(null);
    const advantagesRef = (0, react_1.useRef)(null);
    const formFooterRef = (0, react_1.useRef)(null);
    const scrollToRef = (wichComp) => {
        var _a, _b, _c;
        switch (wichComp) {
            case 'advantages':
                (_a = advantagesRef === null || advantagesRef === void 0 ? void 0 : advantagesRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
                break;
            case 'formFooter':
                (_b = formFooterRef === null || formFooterRef === void 0 ? void 0 : formFooterRef.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: 'smooth' });
                break;
            default:
                (_c = aboutRef === null || aboutRef === void 0 ? void 0 : aboutRef.current) === null || _c === void 0 ? void 0 : _c.scrollIntoView({ behavior: 'smooth' });
                break;
        }
    };
    (0, react_1.useEffect)(() => {
        document.title = '360 Suítes - Área do proprietário';
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(LandingHeader_1.default, { scrollToRef: scrollToRef }),
        react_1.default.createElement(Introduction_1.default, null),
        react_1.default.createElement(Contact_1.default, null),
        react_1.default.createElement(About_1.default, { ref: aboutRef }),
        react_1.default.createElement(Advantages_1.default, { ref: advantagesRef }),
        react_1.default.createElement(LandingForm_1.default, { ref: formFooterRef, scrollToRef: scrollToRef }),
        react_1.default.createElement(LandingFooter_1.default, null)));
};
exports.default = LandingPage;
